// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "client/" + ({"41":"status-screens","112":"seating-plan-modal","189":"date-picker","200":"wix-i18n-config_intl-pluralrules","344":"wix-i18n-config_intl-relativetimeformat","680":"form"}[chunkId] || chunkId) + ".chunk.min.js";
};